import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiFormControl-root': {
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
                width: '100%',
            },
        },
    },
}))

export function Form(props) {
    const classes = useStyles()
    return <form className={classes.root}>{props.children}</form>
}

export default Form
